import ComponentHelper from '../../supers/ComponentHelper';
import { NavLink, Redirect, Route } from 'react-router-dom';
import React from 'react';
import './application-builder.css';
import AppDefPanel from './app-def-panel/AppDefPanel';
import EntityDefPanel from './entity-def-panel/EntityDefPanel';

class ApplicationBuilderPanel extends ComponentHelper {
	render() {
		return (
			<div className="application-builder-view animated fadeIn">
				<div className="def-management-view">
					<div className="header hbox grow-1">
						<div className="title">Application Builder</div>
					</div>
					<div className="tab-ctn hbox grow-1 animated fadeIn">
						<NavLink to={`/application-builder/app-definitions`} className="tab vbox vcenter hcenter">
							Application Definitions
						</NavLink>
						<NavLink to={`/application-builder/entity-definitions`} className="tab vbox vcenter hcenter">
							Entity Definitions
						</NavLink>
					</div>
					<div className="tab-content">
						<Route exact path="/application-builder" render={() => <Redirect to={`/application-builder/app-definitions`} />} />
						<Route exact path={`/application-builder/app-definitions`} component={AppDefPanel} />
						<Route exact path={`/application-builder/entity-definitions`} component={EntityDefPanel} />
					</div>
				</div>
			</div>
		);
	}
}

export default ApplicationBuilderPanel;



// WEBPACK FOOTER //
// ./src/views/application-builder/ApplicationBuilderPanel.js